import { render } from "./BFormRadio.vue?vue&type=template&id=5272ebf9&scoped=true"
import script from "./BFormRadio.vue?vue&type=script&lang=js"
export * from "./BFormRadio.vue?vue&type=script&lang=js"

import "./BFormRadio.vue?vue&type=style&index=0&id=5272ebf9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5272ebf9"]])

export default __exports__